import { useNavigate } from "react-router";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import Box from "../../../components/Box";
import Button from "../../../components/Button";
import Confirm, { StyledDialog } from "../../../components/Confirm";
import useDeleteRevitParameterTemplate from "../useDeleteRevitParameterTemplate";


const Styled = styled(Box)`
    background: #e48383;
    color: #000;

    span {
        font-family: var(--font-mono);
        font-size: 1rem;
        max-width: 464px;
    }

    button {
        align-self: flex-end;
    }
`;

export default function Delete(props) {
    const { __typename, id } = props;

    const [execute] = useDeleteRevitParameterTemplate(id, __typename);

    const navigate = useNavigate();

    const [Dialog, open, close] = useDialog({ Component: StyledDialog });

    async function remove() {
        await execute();
        await navigate("..");
    }

    return (
        <Styled name="delete">
            <span>Removing the template prevents the parameter from being inserted into Revit.</span>
            <Button onClick={ open }>
                Delete
            </Button>
            <Dialog>
                <Confirm
                    no={ close }
                    yes={ remove }
                >
                    <h1>Delete Revit Parameter Template?</h1>
                </Confirm>
            </Dialog>
        </Styled>
    );
}
